export default {
  name: 'home',
  components: {

  },
  data() {
    return {
      userInfo: {
        account: {}
      },
      states: {},
      detailDatas: {},
      shows1: false,
      ruleForm: {
        money: '',
        bid :'',
      },
      shows:false,
      configData:{},
    }
  },
  created() {

  },
  mounted: function () {
    this.getNavs()
    this.getInfo()
    this.getAccount()
    this.getConfig();
  },
  methods: {
    getConfig(){
      this.apiGet('/h5/api/user/withdrawal/getConfig', {}, res => {
        if (res.state) {
          this.configData = res.data || {}
        } else { }
      })
    },
    
    tixian(){
      if(!this.userInfo.alipay_id){
        this.$alert(`<div style="font-size:18px;line-height:30px;color:red;">未绑定支付宝，请先绑定</div>`, '', {
          dangerouslyUseHTMLString: true,
          confirmButtonText: '立即绑定',
          callback: action => {
            console.log(action)
            if(action=='confirm'){
              this.toBindAli();
            }
           
          }
        })
        return;
      }
      if(this.userInfo.account.validmoney>=0){
        this.shows=true;
        if(this.userInfo.account.validmoney>=Number(this.configData.single_max_withdrawal_money)){
          this.ruleForm.money=Number(this.configData.single_max_withdrawal_money);
        }else{
          
        }
      }else{
        this.$message('额度不足,每次1~'+this.configData.single_max_withdrawal_money+'元')
      }
    },
    save() {
      // if (!this.ruleForm.money) {
      //   this.$message('请输入提现金额')
      //   return
      // }
      // console.log(this.ruleForm.money, this.validmoney)
      if (!this.ruleForm.money) {
        this.$message('请输入提现金额')
        return
      }
      if (Number(this.ruleForm.money>Number(this.configData.single_max_withdrawal_money))) {
        this.$message('每次提现最大'+this.configData.single_max_withdrawal_money)
        return
      }
      if (Number(this.ruleForm.money>this.userInfo.account.validmoney)) {
        this.$message('可提现余额不足，请重新输入')
        return
      }

      // if(Number(this.configData.day_used_withdrawal_count)>=Number(this.configData.day_max_withdrawal_count)){
      //   this.$message('每天最多提现'+this.configData.day_max_withdrawal_count+'次')
      //   return;
      // }
      this.apiGet('/h5/api/user/withdrawal/postData', this.ruleForm, res => {
        if (res.state) {
          this.shows=false;
          this.getInfo()
          this.getConfig();
          this.$alert(`<div style="font-size:18px;line-height:30px;color:red;">${res.msg}</div>`, '', {
            dangerouslyUseHTMLString: true,
            confirmButtonText: '确定',
            callback: action => {
              // this.$router.replace({
              //   path: '/accountList', query: {}
              // })
            }
          })
          // setTimeout(d => {
          //   this.getInfo()
          // }, 1500)
        } else {
          this.$alert(res.msg)
          // if (res.msg.indexOf('请联系客服微信') != '-1') {
          //   let data = res.msg.split('：')
          //   this.showMsg = data[0]
          //   this.codeImg = data[1]
          // } else {
          //   this.showMsg = res.msg
          // }

          // this.shows = true
        }
      })
    },
    toWithdrawal: function (item) {
      this.$router.push({
        path: '/accountList',
        // path: '/withdrawal',
        query: {}
      })
    },
    getAccount: function () {
      let bid = localStorage.getItem('bid') || ''
      this.apiGet('/h5/api/user/account/getAccountById', { bid: bid }, res => {
        // this.apiGet("/h5/api/user/account/getAccountById", { bid: bid }, res => {
        if (res.state) {
          this.detailDatas = res.data || {}
        } else { }
      })
    },
    getNavs: function () {
      this.apiGet('/h5/api/user/orderStateList', '', res => {
        if (res.state) {
          res.data.forEach(d => {
            this.states[d.state] = d.size
          })
          this.$forceUpdate()
          console.log('this.states', this.states)
        } else {
          this.$message(res.msg)
        }
      })
    },
    getInfo: function (code) {
      this.apiGet('/h5/api/user/getUserInfo', '', res => {
        if (res.state) {
          this.userInfo = res.data;
          if(res.data.account.validmoney){
            this.ruleForm.money=res.data.account.validmoney
            
          }else{
            this.ruleForm.money=0;
          }
          if(res.data.account.b_id){
            this.ruleForm.bid =res.data.account.b_id;
            
          }else{
            this.ruleForm.bid ='';
          }
        } else { }
      })
    },
    toHb: function () {
      this.$message('正在开发')
    },
    toLinks: function () {
      this.$router.push({ path: '/links' })
    },
    toHome: function () {
      this.$router.push({ path: '/home' })
    },
    toBindAli: function () {
      this.$router.push({ path: '/bindAli' })
    },
    toList: function (num = '2') {
      this.$router.push({ path: '/list?id=' + num })
    },
    toPages: function (url) {
      this.$router.push({ path: url })
    }

    // /h5/api/user/setAlipay
  }

}



// WEBPACK FOOTER //
// ./src/views/my/my.js